export const currentUser = {
  name: "김민준",
  avatar: "https://public.readdy.ai/ai/img_res/25973e0338329aab2de0c1bce115c6e4.jpg",
  streak: 14,
  growPoints: 2400,
  level: "수익 탐험가",
  levelIcon: "💸",
};

export const todayChallenges = [
  {
    id: 1,
    category: "칼퇴 자동화",
    categoryColor: "#00D873",
    title: "주간 보고서 자동화 프롬프트 완성하기",
    desc: "반복되는 주간 보고서를 ChatGPT에게 맡기는 프롬프트를 만들어보세요. 완성하면 매주 2시간 절약.",
    duration: "15분",
    points: 50,
    difficulty: "쉬움",
    completed: false,
    icon: "ri-timer-flash-line",
  },
  {
    id: 2,
    category: "N잡 수익화",
    categoryColor: "#FF8C00",
    title: "미드저니로 이모티콘 시안 3개 만들기",
    desc: "카카오 이모티콘 승인을 위한 시안을 AI로 제작해보세요. 이 챌린지로 월 수익 루틴을 시작하세요.",
    duration: "20분",
    points: 80,
    difficulty: "보통",
    completed: true,
    icon: "ri-money-dollar-circle-line",
  },
  {
    id: 3,
    category: "파티 챌린지",
    categoryColor: "#FF6B6B",
    title: "팀과 함께 AI 쇼츠 수익화 프로젝트",
    desc: "4명이 스크립트·이미지·편집·배포를 AI로 분담해 쇼츠 수익화 조건 달성에 도전합니다.",
    duration: "60분",
    points: 300,
    difficulty: "파티",
    completed: false,
    isParty: true,
    icon: "ri-group-line",
  },
];

export const valueTracker = {
  savedHours: 24.5,
  savedHoursThisMonth: 8.5,
  estimatedValue: 420000,
  estimatedValueThisMonth: 145000,
  completedProjects: 3,
  completedProjectsThisMonth: 1,
  history: [
    { week: "4주 전", hours: 3.5, value: 60000 },
    { week: "3주 전", hours: 5.0, value: 85000 },
    { week: "2주 전", hours: 7.5, value: 130000 },
    { week: "이번 주", hours: 8.5, value: 145000 },
  ],
};

export const badges = [
  { id: 1, icon: "🔥", name: "7일 연속", earned: true },
  { id: 2, icon: "💸", name: "첫 수익화", earned: true },
  { id: 3, icon: "⏰", name: "칼퇴 달성", earned: true },
  { id: 4, icon: "🤖", name: "AI 탐험가", earned: true },
  { id: 5, icon: "🎯", name: "챌린지 10개", earned: true },
  { id: 6, icon: "🏆", name: "월간 Top10", earned: false },
  { id: 7, icon: "💎", name: "다이아 레벨", earned: false },
  { id: 8, icon: "🚀", name: "30일 연속", earned: false },
];

export const contributionData: number[][] = [
  [0, 1, 0, 2, 1, 0, 0],
  [1, 2, 1, 3, 2, 1, 0],
  [0, 1, 2, 1, 0, 2, 1],
  [2, 3, 2, 3, 1, 0, 1],
  [1, 2, 3, 2, 3, 2, 1],
  [0, 1, 2, 3, 2, 1, 2],
  [1, 2, 1, 2, 3, 2, 1],
  [2, 1, 3, 2, 1, 3, 2],
  [3, 2, 1, 3, 2, 1, 0],
  [1, 3, 2, 1, 2, 3, 2],
  [2, 1, 3, 2, 3, 1, 2],
  [1, 2, 2, 3, 1, 2, 3],
];

export const redeemItems = [
  { id: 1, name: "스타벅스 아메리카노", points: 800, icon: "☕", category: "카페" },
  { id: 2, name: "GS25 5,000원 상품권", points: 1200, icon: "🏪", category: "편의점" },
  { id: 3, name: "쿠팡캐시 3,000원", points: 700, icon: "📦", category: "쇼핑" },
  { id: 4, name: "넷플릭스 1개월", points: 3500, icon: "🎬", category: "구독" },
  { id: 5, name: "AI 인턴 채용 5,000원 할인", points: 500, icon: "💰", category: "구독료 방어" },
  { id: 6, name: "AI 실무자 채용 1개월 무료", points: 2500, icon: "🤖", category: "구독료 방어" },
  { id: 7, name: "프리미엄 노하우 잠금 해제", points: 300, icon: "🔓", category: "프리미엄 콘텐츠" },
  { id: 8, name: "배달의민족 5,000원", points: 1500, icon: "🍜", category: "배달" },
];

export const pointHistory = [
  { id: 1, desc: "오늘의 업무 지시 3개 완료 — 성과급 입금", points: 150, date: "오늘", type: "earn" },
  { id: 2, desc: "💰 프롬프트 로열티 — 3명이 내 프롬프트 복사", points: 30, date: "오늘", type: "royalty" },
  { id: 3, desc: "7일 연속 달성 — 연속 보너스 배당금", points: 200, date: "오늘", type: "earn" },
  { id: 4, desc: "파티 챌린지 완료 — 팀 성과급", points: 300, date: "어제", type: "earn" },
  { id: 5, desc: "💰 프롬프트 로열티 — 누군가 내 프롬프트 복사", points: 10, date: "어제", type: "royalty" },
  { id: 6, desc: "AI 인턴 채용 5,000원 할인 사용", points: -500, date: "3일 전", type: "spend" },
  { id: 7, desc: "보고서 자동화 챌린지 완료 — 성과급", points: 80, date: "4일 전", type: "earn" },
  { id: 8, desc: "💰 프롬프트 로열티 — 이모티콘 프롬프트 복사 x2", points: 20, date: "5일 전", type: "royalty" },
];

export const partyChallenge = {
  title: "AI 쇼츠 수익화 대작전",
  deadline: "D-2",
  totalPoints: 1200,
  members: [
    {
      id: 1,
      name: "한예린",
      role: "스크립트 담당",
      avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20casual%20portrait%20clean%20background%20minimal%20photography%20headshot&width=60&height=60&seq=pm1&orientation=squarish",
      joined: true,
    },
    {
      id: 2,
      name: "정우진",
      role: "이미지 담당",
      avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20casual%20portrait%20clean%20background%20minimal%20photography%20headshot&width=60&height=60&seq=pm2&orientation=squarish",
      joined: true,
    },
    { id: 3, name: "", role: "영상 편집 담당", avatar: "", joined: false },
    { id: 4, name: "", role: "배포·홍보 담당", avatar: "", joined: false },
  ],
};
